import { Ayuda } from "@puntaje/nebulosa/api-services"
import { BaseModel } from "@puntaje/shared/core"

export class AyudaCategoriaAyuda extends BaseModel {
    public categoria_ayuda_id: number
    public ayuda_id: number
    public orden: number
    public ayuda: Ayuda
}
